import React from 'react';
import { Hero } from '../components/Hero';
import { WhatIsCognarchism } from '../components/WhatIsCognarchism';
import { NCJISection } from '../components/NCJISection';
import { ConstitutionalOrder } from '../components/ConstitutionalOrder';
import { DevelopmentalStatecraft } from '../components/DevelopmentalStatecraft';
export function Home() {
  return <>
      <Hero data-id="element-331" />
      <WhatIsCognarchism data-id="element-332" />
      <NCJISection data-id="element-333" />
      <ConstitutionalOrder data-id="element-334" />
      <DevelopmentalStatecraft data-id="element-335" />
    </>;
}